module.exports = (s) => {
  return [
    {
      name: '关键词',
      value: 'word',
    },
    {
      name: '推荐理由',
      value: 'recommend_reason',
      width: 200,
      format: ({ recommend_reason }) => {
        return recommend_reason ? recommend_reason.split(';').join('、') : '-';
      },
    },
    {
      name: '月均搜索量',
      value: 'month_query_count',
      width: 100,
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '点击量',
      value: 'click_count',
      width: 80,
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '竞争程度',
      value: 'total_accts',
      width: 105,
      props: {
        sortable: 'custom',
      },
      format: ({ total_accts }) => {
        const h = s.$createElement;
        const ele = h('BarChart',
          {
            props: {
              width: '80px',
              height: '40px',
              num: total_accts,
              sum: 5,
            },
          },
          null,
        );
        return ele;
      },
    },
    {
      name: '指导价',
      value: 'price',
      width: 80,
      props: {
        sortable: 'custom',
      },
      format: ({ price }) => {
        return price || price === 0 ? `${price}元` : '-';
      },
    },
  ];
};
